import React from 'react';
import UserList from '../components/UserList';
import AdminLayout from 'cms/core/shared/AdminLayout';
import { Box, Typography, Breadcrumbs, Link as MuiLink } from '@mui/material';
import { Link } from 'react-router-dom';

function UsersScreen() {
  return (
    <AdminLayout pageTitle="Users">
      {/* <Box sx={{ mb: 3 }}>
        <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 2 }}>
          <MuiLink component={Link} to="/cms" color="inherit">
            Home
          </MuiLink>
          <Typography color="text.primary">Users</Typography>
        </Breadcrumbs>
        <Typography variant="h4" fontWeight={700} gutterBottom color="text.primary">
          Users
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Manage all users in the system
        </Typography>
      </Box> */}
      <UserList />
    </AdminLayout>
  );
}

export default UsersScreen;
